import React, {useState, useEffect,useContext} from 'react';
import { RootStoreContext } from '../stores/RootStore';
import { HistoryList, HistoryParam } from '../models/StudyEvaluation';
import { ISelect } from '../models/General';
import Select from "react-select";
import MaterialTable from "material-table";
import { TableIcons } from '../utils/Icons';
import { Redirect,Link } from 'react-router-dom';
import { CircleSpinnerOverlay } from 'react-spinner-overlay';

const HistoryListPage = (props:any) => {
    

    const institutionValDefault = props?.location?.state?.institutionVal;
    const careerValDefault = props?.location?.state?.careerVal;
    const semesterValDefault = props?.location?.state?.semesterVal;
    const programByinstitutionValDefault = props?.location?.state?.programByinstitutionVal;

    const rootStore = useContext(RootStoreContext);
    const { getHistoryList } = rootStore.studyEvaluationStore;
    const { getInstitution, getCareer, getProgramByInstitution, getSemester} = rootStore.commonStore; 
    const emplidVal =  window.localStorage.getItem('emplid'); 

    const [list, setList] = useState<HistoryList[]>([]) 
    const [institution, setInstitution] = useState<ISelect[]>();
    const [institutionVal, setInstitutionVal] = useState<string>(institutionValDefault ? institutionValDefault : '');
    const [InstitutionShownVal, setInstitutionShownVal] = useState<ISelect>(); // untuk value yang ditampilkan di user
    const [career, setCareer] = useState<ISelect[]>();
    const [careerVal, setCareerVal] = useState<string>(careerValDefault ? careerValDefault : '');
    const [careerShownVal, setCareerShownVal] = useState<ISelect>(); // untuk value yang ditampilkan di user
    const [programByInstitution, setProgramByInstitution] = useState<ISelect[]>();
    const [programByinstitutionVal, setProgramByInstitutionVal] = useState<string>(programByinstitutionValDefault ? programByinstitutionValDefault : '');
    const [programShownVal, setProgramShownVal] = useState<ISelect>(); // untuk value yang ditampilkan di user
    const [semester, setSemester] = useState<ISelect[]>();
    const [semesterVal, setSemesterVal] = useState<string>(semesterValDefault ? semesterValDefault: '');
    const [semesterShownVal, setSemesterShownVal] = useState<ISelect>(); // untuk value yang ditampilkan di user
    const [status, setStatus] = useState(false);
    const [historyId, setHistoryId] = useState<number>(0);
    const [emplid, setEmplid] = useState<string>("");
    const [btnExport, setBtnExport] = useState(true) 

    const [isLoading, setIsLoading] = useState(false);

    var columns = [
        {title: "history_id", field: "history_id", hidden: true},
        {title: "ID", field: "EMPLID"},
        {title: "Name", field: "NAME_DISPLAY"},
        {title: "Class Of", field: "CLASS_OF"},
        {title: "Program", field: "ACAD_PROGRAM"},
        {title: "Semester", field: "SEMESTER"},
        {title: "Warning Letter", field: "WARNING_LETTER"},
        {title: "Advisor", field: "ADVISOR_NAME"},
        {
            title: "Detail",
            render: (rowData:any) => (
            <div className="btn btn-info" onClick={() => detailHistory(rowData)}>Detail</div>
            )
        },
        {
            title: "Print",
            render: (rowData:any) => (<button hidden={checkFile(rowData.FILENAME)}  className="btn btn-secondary" onClick={() => print(rowData)}>Print</button>)
        }
    ]

    const checkFile = (filename:string) => {
        return filename === null ? true : false;
    }

    function print(event: any) 
    {
        const token = window.localStorage.getItem('token');
        let file = `${process.env.REACT_APP_API_URL}/academic/evaluation-process/download/${event.HISTORY_ID}`;
        let anchor = document.createElement("a");
        document.body.appendChild(anchor);

        let headers = new Headers();
        headers.append('Authorization', `Bearer ${token}`);
        headers.append('Content-Type', 'application/json');

        fetch(file, { 
            headers,
            method: 'get'
            
        })
        .then(response => response.blob())
        .then(blobby => {
            let objectUrl = window.URL.createObjectURL(blobby);

            anchor.href = objectUrl;
            anchor.download = event.FILENAME;
            anchor.click();

            window.URL.revokeObjectURL(objectUrl);
        });
    };

    function exportExcel() 
    {
        const token = window.localStorage.getItem('token');
        let file = `${process.env.REACT_APP_API_URL}/academic/history/export/${institutionVal}/${programByinstitutionVal}/${semesterVal}`;
        let anchor = document.createElement("a");
        document.body.appendChild(anchor);

        let headers = new Headers();
        headers.append('Authorization', `Bearer ${token}`);
        headers.append('Content-Type', 'application/json');

        fetch(file, { 
            headers,
            method: 'get'
            
        })
        .then(response => response.blob())
        .then(blobby => {
            let objectUrl = window.URL.createObjectURL(blobby);

            anchor.href = objectUrl;
            anchor.download = 'List History SP.xls';
            anchor.click();

            window.URL.revokeObjectURL(objectUrl);
        });
    };

    function detailHistory(event: any) {
        setStatus(true)
        setHistoryId(event.HISTORY_ID)
        setEmplid(event.EMPLID)
    };

    function handleInstitutionSelect(event: any) {
        setInstitutionVal(event.value);
        setInstitutionShownVal(event)

        getCareerData(String(emplidVal), event.value,false)
    };

    function handleCareerSelect(event: any) {
        setCareerVal(event.value)
        setCareerShownVal(event)

        getProgramData(String(emplidVal),institutionVal, event.value,false)

        getSemesterData(institutionVal, event.value,false)
    };

    function handleProgramByInstitutionSelect(event: any) {
        setProgramByInstitutionVal(event.value)
        setProgramShownVal(event)
    };

    function handleSemesterSelect (event: any) {
        setSemesterVal(event.value)
        setSemesterShownVal(event)
        if(event.value!=""){
            setBtnExport(false)
        }
    };

    const getCareerData = (emplid:string,institution:string,loadDefault:boolean) => {
        const careerData = getCareer(emplid, institution);
        careerData.then(function(result) {
            setCareer(result);

            if(loadDefault){
                loadDefaultData(result,careerValDefault,setCareerShownVal)
            }
            
        })
    }

    const getProgramData = (emplid:string,institution:string,career:string,loadDefault:boolean) => {
        const programByInstitutionData = getProgramByInstitution(emplid, institution, career);
        programByInstitutionData.then(function(result) {
            setProgramByInstitution(result);

            if(loadDefault){
                loadDefaultData(result,programByinstitutionValDefault,setProgramShownVal)
            }
        })
    }

    const getSemesterData = (institution:string, career:string,loadDefault:boolean)=> {
        const semesterData = getSemester(institution, career);
        semesterData.then(function(result) {
            setSemester(result);

            if(loadDefault){
                loadDefaultData(result,semesterValDefault,setSemesterShownVal)
            }
        })
    }

    const loadDefaultData = (result:any,defData:any,setter:any) => {
        
        let checkResult = result.filter((e: { value: any; }) => e.value === defData)
        if (checkResult.length > 0) {
            setter(checkResult[0])
        }
        
    }

    useEffect(() => {

        const institutionData = getInstitution(String(emplidVal));
        institutionData.then(function(result) {
            setInstitution(result);
            if(institutionValDefault){
                loadDefaultData(result,institutionValDefault,setInstitutionShownVal)
                if(careerValDefault){
                    getCareerData(String(emplidVal),institutionValDefault,true)
                    if(programByinstitutionValDefault){
                        getProgramData(String(emplidVal),institutionValDefault,careerValDefault,true)
                        if(semesterValDefault){
                            getSemesterData(institutionValDefault,careerValDefault,true)
                        }
                    }
                }
            }
        })

        const param: HistoryParam = {
            INSTITUTION: String(institutionVal),
            PROGRAM: String(programByinstitutionVal),
            SEMESTER: String(semesterVal),
        };

        if (semesterVal != "") {
            setIsLoading(true);
        }

        getHistoryList(param).then(function(response) {
            setList(response);
            setIsLoading(false);
        })  
    },[institutionVal, programByinstitutionVal, semesterVal, btnExport])

    return (
        <React.Fragment>
            {isLoading
            ? <CircleSpinnerOverlay zIndex={2000} loading={isLoading}　color="#00FFFF" />
            : <></>
            } 
           <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">History</h1>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-5">
                                            <div className="form-group">
                                                <label><span className='required-symbol'>*</span>Institution</label>
                                                <Select
                                                    name="institution"
                                                    placeholder="Choose Institution"
                                                    options={institution}
                                                    onChange={handleInstitutionSelect}
                                                    value={InstitutionShownVal}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-5">
                                            <div className="form-group">
                                                <label><span className='required-symbol'>*</span>Career</label>
                                                <Select
                                                    name="career"
                                                    placeholder="Choose Career"
                                                    options={career}
                                                    onChange={handleCareerSelect}
                                                    value={careerShownVal}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-5">
                                            <div className="form-group">
                                                <label><span className='required-symbol'>*</span>Program</label>
                                                <Select
                                                    name="program"
                                                    placeholder="Choose Program"
                                                    options={programByInstitution}
                                                    onChange={handleProgramByInstitutionSelect}
                                                    value={programShownVal}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-5">
                                            <div className="form-group">
                                                <label><span className='required-symbol'>*</span>Semester</label>
                                                <Select
                                                    name="semester"
                                                    placeholder="Choose Semester"
                                                    options={semester}
                                                    onChange={handleSemesterSelect}
                                                    value={semesterShownVal}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-1">
                                            <div className="form-group">
                                                <label> &nbsp;</label>
                                                <button hidden={btnExport}  onClick={() => exportExcel()} className="btn btn-info" type="button">Export</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <h3 className="card-title">Students List</h3>
                                </div>
                                <div className="card-body">
                                    <MaterialTable
                                        title=""
                                        icons={TableIcons}
                                        columns={columns}
                                        data={list}
                                        options={{
                                            filtering: true,
                                            selection: false,
                                            emptyRowsWhenPaging: false,
                                            pageSize: 25,
                                            pageSizeOptions: [5, 10, 25, 50],
                                            headerStyle: {
                                                fontWeight: 'bold',
                                            },
                                            rowStyle: rowData => ({
                                                backgroundColor: rowData.tableData.id % 2 === 0 ? "#EEE" : "#FFF",
                                            }),
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {
                status ? 
                <>   
                    return <Redirect push 
                        to={{
                            pathname: "/detail",
                            state: {
                             historyid: historyId,
                             emplid: emplid,
                             institution : institutionVal,
                             career: careerVal,
                             semester:semesterVal,
                             program:programByinstitutionVal
                            }
                         }}
                        /> 
                </> : <></> 
            }
        </React.Fragment>
    );
}

export default HistoryListPage;